(function(){
	'use strict';

	var $scrollBtn = $('.smp-home-banner-scroll-btn');

	if($scrollBtn.length){

		var $parentBanner = $scrollBtn.closest('.smp-home-banner'),
		bannerOffset = null;

		if($parentBanner.length){
			bannerOffset = ($parentBanner.offset().top + $parentBanner.outerHeight()) + 'px';
			squiz.fn.smpScrollTopBtn('.smp-home-banner-scroll-btn', bannerOffset);
		}
	}

	if($('.smp-home-banner-inner').length) {
		$('.smp-home-banner-inner').slick({
			prevArrow: '<button type="button" class="slick-prev"><span class="fas fa-chevron-left"></span><span class="sr-only">Previous</span></button>',
            nextArrow: '<button type="button" class="slick-next"><span class="fas fa-chevron-right"></span><span class="sr-only">Next</span></button>'
		});
	}

}());
